var createInputTypeMap = function (map) { return map; };
export default createInputTypeMap;
//# sourceMappingURL=createInputTypeMap.js.map